import React, { useState } from "react";
import MetaData from "../../components/MetaData";
import { ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createNewBusiness, onUpdateBusiness } from "../../slices/thunks";
import { useProfile } from "../../components/Hooks/UserHooks";
import { updateBusinessDetail } from "../../slices/auth/login/reducer";
import ImageOne from "../writepost/ImageOne";
import BusinessLogo from "./businessLogo";

const RegisterBusiness = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userProfile } = useProfile();
  const [logo, setLogo] = useState("");
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      business_name: userProfile?.user?.businessDetail?.business_name || "",
      business_category:
        userProfile?.user?.businessDetail?.business_category || "",
      website: userProfile?.user?.businessDetail?.website || "",
      description: userProfile?.user.businessDetail?.description || "",
      phone_number: userProfile?.user?.businessDetail?.phone_number || "",
      profile_facebook:
        userProfile?.user?.businessDetail?.profile_facebook || "",
      profile_linkedin:
        userProfile?.user?.businessDetail?.profile_linkedin || "",
      profile_twitter: userProfile?.user?.businessDetail?.profile_twitter || "",
      logo:  userProfile?.user?.businessDetail?.logo || "",
      hours: {
        monday: {
          open:
            userProfile?.user?.businessDetail?.hours?.monday?.open || "09:00",
          close:
            userProfile?.user?.businessDetail?.hours?.monday?.close || "17:00",
        },
        tuesday: {
          open:
            userProfile?.user?.businessDetail?.hours?.tuesday?.open || "09:00",
          close:
            userProfile?.user?.businessDetail?.hours?.tuesday?.close || "17:00",
        },
        wednesday: {
          open:
            userProfile?.user?.businessDetail?.hours?.wednesday?.open ||
            "09:00",
          close:
            userProfile?.user?.businessDetail?.hours?.wednesday?.close ||
            "17:00",
        },
        thursday: {
          open:
            userProfile?.user?.businessDetail?.hours?.thursday?.open || "09:00",
          close:
            userProfile?.user?.businessDetail?.hours?.thursday?.close ||
            "17:00",
        },
        friday: {
          open:
            userProfile?.user?.businessDetail?.hours?.friday?.open || "09:00",
          close:
            userProfile?.user?.businessDetail?.hours?.friday?.close || "17:00",
        },
        saturday: {
          open: userProfile?.user?.businessDetail?.hours?.saturday?.open || "",
          close:
            userProfile?.user?.businessDetail?.hours?.saturday?.close || "",
        },
        sunday: {
          open: userProfile?.user?.businessDetail?.hours?.sunday?.open || "",
          close: userProfile?.user?.businessDetail?.hours?.sunday?.close || "",
        },
      },
      location:userProfile?.user?.businessDetail?.location || "",
    },
    validationSchema: Yup.object({
      business_name: Yup.string().required("Please Enter Business Name"),
      business_category: Yup.string().required(
        "Please Enter Business Category"
      ),
      website: Yup.string().required("Please Enter Website Url"),
      description: Yup.string().required("Please Enter Description"),
      logo: Yup.string().required("Please upload an image"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const data = {
          business_logo: values["business_logo"],
          business_name: values["business_name"],
          business_category: values["business_category"],
          website: values["website"],
          description: values["description"],
          phone_number: values["phone_number"],
          profile_facebook: values["profile_facebook"],
          profile_linkedin: values["profile_linkedin"],
          profile_twitter: values["profile_twitter"],
          status: "pending",
          location: values["business_location"],
          hours: values.hours,
          logo: values["logo"],

          
        };

        let res;
        if (userProfile?.user?.businessDetail) {
          let bussinessID = userProfile?.user?.businessDetail?._id;
          res = await dispatch(onUpdateBusiness({ bussinessID, data }));
        } else {
          res = await dispatch(createNewBusiness(data));
        }

        if (res?.payload?.status) {
          dispatch(updateBusinessDetail(data));
          setLogo("");
          validation.resetForm();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });
console.log(userProfile)
  return (
    <>
      <MetaData
        metaTitle={"Create Business"}
        metaDescription={"Softorithm write your post"}
        robots="noindex, nofollow"
      />

      <div className="page_body">
        <ToastContainer closeButton={false} />
        <div className="convert_tool_wrapper">
          <div className="pg_title">
            <h2>
              {userProfile?.user?.businessDetail ? "Update" : "Create"}{" "} 
              Your Business Profile
            </h2>
          </div>

          <Row className=" justify-content-center ">
            <Col lg={7}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
                action="#"
              >
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="business_name">
                            Business Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="business_name"
                            placeholder="Enter Business Name"
                            name="business_name"
                            value={validation.values.business_name || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.business_name &&
                              validation.touched.business_name
                                ? true
                                : false
                            }
                          />
                          {validation.errors.business_name &&
                          validation.touched.business_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.business_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="business_category"
                          >
                            Business Category
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="business_category"
                            placeholder="Enter Business Category"
                            name="business_category"
                            value={validation.values.business_category || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.business_category &&
                              validation.touched.business_category
                                ? true
                                : false
                            }
                          />
                          {validation.errors.business_category &&
                          validation.touched.business_category ? (
                            <FormFeedback type="invalid">
                              {validation.errors.business_category}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Business Logo
                          </Label>
                          <BusinessLogo
                            validation={validation}
                            logo={logo}
                            setLogo={setLogo}
                          />
                        </div>
                      </Col>

                      <Col>
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="description">
                            Description
                          </Label>
                          <Input
                            type="textarea"
                            className="form-control"
                            rows={4}
                            id="description"
                            placeholder="Enter Description"
                            name="description"
                            value={validation.values.description || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.description &&
                              validation.touched.description
                                ? true
                                : false
                            }
                          />
                          {validation.errors.description &&
                          validation.touched.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <div className="">
                        <h4>Contact Information</h4>
                      </div>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="phone_number">
                            Phone Number
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="phone_number"
                            placeholder="Enter Phone Number"
                            name="phone_number"
                            value={validation.values.phone_number || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.phone_number &&
                              validation.touched.phone_number
                                ? true
                                : false
                            }
                          />
                          {validation.errors.phone_number &&
                          validation.touched.phone_number ? (
                            <FormFeedback type="invalid">
                              {validation.errors.phone_number}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="website">
                            Website
                          </Label>
                          <Input
                            type="url"
                            className="form-control"
                            id="website"
                            placeholder="Enter Website"
                            name="website"
                            value={validation.values.website || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.website &&
                              validation.touched.website
                                ? true
                                : false
                            }
                          />
                          {validation.errors.website &&
                          validation.touched.website ? (
                            <FormFeedback type="invalid">
                              {validation.errors.website}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col>
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="business_location">
                            Location
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="business_location"
                            placeholder="Enter Location"
                            name="business_location"
                            value={validation.values.business_location || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.business_location &&
                              validation.touched.business_location
                                ? true
                                : false
                            }
                          />

                          {validation.errors.business_location &&
                          validation.touched.business_location ? (
                            <FormFeedback type="invalid">
                              {validation.errors.business_location}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <div className="">
                        <h4>Social Profiles</h4>
                      </div>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="profile_facebook"
                          >
                            Facebook
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="profile_facebook"
                            placeholder="Facebook Url"
                            name="profile_facebook"
                            value={validation.values.profile_facebook || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.profile_facebook &&
                              validation.touched.profile_facebook
                                ? true
                                : false
                            }
                          />
                          {validation.errors.profile_facebook &&
                          validation.touched.profile_facebook ? (
                            <FormFeedback type="invalid">
                              {validation.errors.profile_facebook}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="profile_linkedin"
                          >
                            Linkedin
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="profile_linkedin"
                            placeholder="Linkedin Url"
                            name="profile_linkedin"
                            value={validation.values.profile_linkedin || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.profile_linkedin &&
                              validation.touched.profile_linkedin
                                ? true
                                : false
                            }
                          />
                          {validation.errors.profile_linkedin &&
                          validation.touched.profile_linkedin ? (
                            <FormFeedback type="invalid">
                              {validation.errors.profile_linkedin}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="profile_twitter"
                          >
                            Twitter
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="profile_twitter"
                            placeholder="Twitter Url"
                            name="profile_twitter"
                            value={validation.values.profile_twitter || ""}
                            onBlur={validation.handleBlur}
                            onChange={validation.handleChange}
                            invalid={
                              validation.errors.profile_twitter &&
                              validation.touched.profile_twitter
                                ? true
                                : false
                            }
                          />
                          {validation.errors.profile_twitter &&
                          validation.touched.profile_twitter ? (
                            <FormFeedback type="invalid">
                              {validation.errors.profile_twitter}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <div className="mb-4">
                        <h4>Business Hours</h4>
                        {Object.keys(validation.values.hours).map((day) => (
                          <Row key={day} className="align-items-center mb-2">
                            <Col md={3}>
                              <Label className="form-label text-capitalize">
                                {day}
                              </Label>
                            </Col>
                            <Col md={4}>
                              <Input
                                type="time"
                                name={`hours.${day}.open`}
                                value={validation.values.hours[day].open}
                                onChange={validation.handleChange}
                              />
                            </Col>
                            <Col md={4}>
                              <Input
                                type="time"
                                name={`hours.${day}.close`}
                                value={validation.values.hours[day].close}
                                onChange={validation.handleChange}
                              />
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </Row>
                  </CardBody>
                </Card>

                <div className="text-end mb-3 mt-3">
                  <button type="submit" className="btn btn-success  ">
                    {loading ? (
                      <Spinner size="sm" className="me-2">
                        {" "}
                        Loading...{" "}
                      </Spinner>
                    ) : null}
                    {userProfile?.user?.businessDetail
                      ? "Update"
                      : "Create"}{" "}
                    Profile
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default RegisterBusiness;
